import { cn } from '@askable/ui/lib/utils';
import { type PropsWithChildren } from 'react';

import { MinimalPage } from 'components/MinimalPage/MinimalPage';

export const ErrorPage = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return (
    <MinimalPage bodyClasses={cn('my-6 h-auto space-y-4 py-4 md:m-auto md:max-w-md', className)}>
      {children}
    </MinimalPage>
  );
};
